/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddToVenueModel as DigiworkMaitreDPosDtoMenuAddToVenueModel } from '../../models/Digiwork/MaitreD/Pos/DTO/Menu/add-to-venue-model';

export interface AddMenuToVenues$Params {
      body?: DigiworkMaitreDPosDtoMenuAddToVenueModel
}

export function addMenuToVenues(http: HttpClient, rootUrl: string, params?: AddMenuToVenues$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, addMenuToVenues.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

addMenuToVenues.PATH = '/api/gmn/Menu/addmenutovenues';
